module.exports = __webpack_public_path__ + "static/img/p15.ffa4efe4.png";